import React from 'react';
import { Spin, Alert } from 'antd';

const selectStyle = {
  width: '100%',
  padding: '4px 11px',
  border: '1px solid #d9d9d9',
  borderRadius: '2px',
  backgroundColor: '#fff',
  fontSize: '14px',
  marginBottom: '8px',
};

const checkboxContainerStyle = {
  maxHeight: '200px',
  overflowY: 'auto',
  border: '1px solid #d9d9d9',
  borderRadius: '2px',
  padding: '8px',
};

const checkboxStyle = {
  display: 'block',
  marginBottom: '4px',
};

const FormSelector = ({ forms, loading, error, selectedForm, selectedFields, onChange, onRetry, formType }) => {
  const handleFormChange = (e) => {
    // For Ninja Forms and CF7, use the raw value as string
    const formId = (formType === 'contactForm7' || formType === 'ninjaForms') 
        ? e.target.value 
        : parseInt(e.target.value, 10);
        
    onChange(formId, []);
};

const handleFieldChange = (e) => {
    // For Ninja Forms and CF7, use the raw value as string
    const fieldId = (formType === 'contactForm7' || formType === 'ninjaForms')
        ? e.target.value 
        : parseInt(e.target.value, 10);
    const isChecked = e.target.checked;
    
    const currentFormFields = getFieldOptions();
    const fieldData = currentFormFields.find(f => 
        (formType === 'contactForm7' || formType === 'ninjaForms')
            ? f.id === fieldId
            : f.id === parseInt(fieldId)
    );

    let updatedFields;
    if (isChecked) {
        updatedFields = [...selectedFields, { 
            id: fieldId, 
            label: e.target.name,
            type: fieldData?.type || 'text'
        }];
    } else {
        updatedFields = selectedFields.filter(field => 
            (formType === 'contactForm7' || formType === 'ninjaForms')
                ? field.id !== fieldId
                : field.id !== parseInt(fieldId)
        );
    }
    
    onChange(selectedForm, updatedFields);
  };

  const getFieldOptions = () => {
    const selectedFormData = forms.find(form => 
        (formType === 'contactForm7' || formType === 'ninjaForms')
            ? form.id === selectedForm
            : form.id === parseInt(selectedForm)
    );
    
    return selectedFormData ? selectedFormData.fields : [];
  };

  if (loading) {
    return <Spin tip={`Loading ${
      formType === 'wpForms' ? 'WPForms' : 
      formType === 'contactForm7' ? 'Contact Form 7' :
      formType === 'ninjaForms' ? 'Ninja Forms' : 
      'Gravity Forms'
    }...`} />;
  }

  if (error) {
    return (
      <Alert
        message="Error"
        description={error}
        type="error"
        showIcon
        action={
          <button onClick={onRetry}>Retry</button>
        }
      />
    );
  }

  if (!forms || forms.length === 0) {
    return <Alert message={`No ${
      formType === 'wpForms' ? 'WPForms' : 
      formType === 'contactForm7' ? 'Contact Form 7' :
      formType === 'ninjaForms' ? 'ninja-forms' :
      'Gravity Forms'
    } found`} type="warning" />;
  }

  return (
    <div>
      <select
        style={selectStyle}
        value={selectedForm || ''}
        onChange={handleFormChange}
        className="nodrag"
      >
        <option value="">Select a form</option>
        {forms.map(form => (
          <option key={form.id} value={form.id}>{form.title}</option>
        ))}
      </select>

      {selectedForm && (
    <div style={checkboxContainerStyle}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Select fields:</label>
        {getFieldOptions().map(field => (
            <label key={field.id} style={checkboxStyle}>
            <input
                type="checkbox"
                value={field.id}
                name={field.label}
                checked={selectedFields.some(f => 
                    formType === 'contactForm7' || formType === 'ninjaForms'
                        ? f.id === field.id 
                        : parseInt(f.id) === parseInt(field.id)
                )}
                onChange={handleFieldChange}
                className="nodrag"
            />
                {' ' + field.label}
                <small style={{ marginLeft: '8px', color: '#888' }}>
                    ({field.type})
                </small>
            </label>
        ))}
    </div>
)}

    {selectedFields.length > 0 && (
      <Alert
        message="Field Access"
        description={
          <div>
            Access selected fields using:<br />
            <code>[[field_label] from {
              formType === 'wpForms' ? 'wpforms' : 
              formType === 'contactForm7' ? 'cf7' :
              formType === 'ninjaForms' ? 'ninja-forms' :
              'gravity-forms'
            }-node-id]</code>
          </div>
        }
        type="info"
        showIcon
        style={{ marginTop: '8px' }}
      />
    )}
    </div>
  );
};

export default FormSelector;